import Yup from 'utils/validation/yup-extensions';
import NPINumberField, { ValidateYupNPI } from 'pages/ApplicationRequest/components/containers/1617BridgesLink/components/NPINumberField';

export const NPISupplement = ({ formik, lastName, firstName }) => {
	return (
		<NPINumberField
			id={FORM_FIELD_KEYS.NPI}
			idVerification={FORM_FIELD_KEYS.NPI_VERIFICATION}
			formik={formik}
			lastName={lastName}
			firstName={firstName}
		/>
	);
};

export const FORM_FIELD_KEYS = {
	NPI: 'NPI',
	NPI_VERIFICATION: 'NPI_VERIFICATION',
	LAST_NAME: 'LAST_NAME',
	FIRST_NAME: 'FIRST_NAME',
	TRACKING_NUMBER: 'TRACKING_NUMBER',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.NPI]: '',
	[FORM_FIELD_KEYS.NPI_VERIFICATION]: false,
	[FORM_FIELD_KEYS.LAST_NAME]: '',
	[FORM_FIELD_KEYS.FIRST_NAME]: '',
	[FORM_FIELD_KEYS.TRACKING_NUMBER]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.NPI]: Yup.string()
		.maxCounter(10)
		.test('isProviderNpi', (value, context) =>
			ValidateYupNPI(value, context),
		),
	[FORM_FIELD_KEYS.NPI_VERIFICATION]: Yup.bool()
		.oneOf([true], 'Please acknowledge.')
		.required('Please acknowledge.'),
};